import MainProvider from './MainProvider';

export default MainProvider;
